/* Shared cart queue. GiftPro owns threshold rewards; Shopify owns native BXGY discounts. */
(() => {
  if (window.MouniCartController) return;
  const root = window.Shopify?.routes?.root || '/';
  const drawer = () => document.getElementById('halo-cart-sidebar');
  const page = () => document.querySelector('[data-mouni-cart-page]');
  const rows = () => document.querySelectorAll('#halo-cart-sidebar .previewCartItem[data-key], [data-mouni-cart-row]');
  const settings = () => document.querySelector('mouni-header-settings')?.dataset || {};
  const pending = new Map();
  let cart = null, running = false, refresh = null, latestSections = null;
  let giftEligible = null, giftCelebrationPending = false;
  const celebrationKey = 'mouni-gift-celebration-v2';
  let giftCelebrated = new Set();
  try { giftCelebrated = new Set(JSON.parse(sessionStorage.getItem(celebrationKey) || '[]')); } catch (_) {}
  const rememberCelebration = shown => {
    if (shown) giftCelebrated.add(shown); else giftCelebrated.clear();
    try { sessionStorage.setItem(celebrationKey, JSON.stringify([...giftCelebrated])); } catch (_) {}
  };
  let giftSync = null, giftSyncSignature = '';
  const burstTimers = new WeakMap();
  let confirmedDrawer = '', confirmedPage = '';
  const api = {get busy() {return running || pending.size > 0;}};
  window.MouniCartController = api;
  api.isGift = item => {
    const properties = item.properties || {};
    if (properties._auto_added_by_rule && String(properties._auto_added) === 'true') return true;
    if (window.MouniQuickCartV37?.isGiftProLine) return window.MouniQuickCartV37.isGiftProLine(item);
    return Object.entries(item.properties || {}).some(([key, value]) => !key.toLowerCase().startsWith('_mouni') && /gift|هدية/i.test(key + ' ' + value)) || (item.line_level_discount_allocations || []).some(a => /gift|هدية/i.test(a.discount_application?.title || ''));
  };
  api.summary = state => (state?.items || []).reduce((sum, item) => {
    if (!api.isGift(item)) {sum.count += item.quantity; sum.total += item.final_line_price; sum.original += item.original_line_price;}
    return sum;
  }, {count: 0, total: 0, original: 0});
  const signature = state => JSON.stringify((state?.items || []).map(i => [i.key, i.quantity, i.final_line_price]));
  const money = cents => new Intl.NumberFormat('en-US', {minimumFractionDigits:2, maximumFractionDigits:2}).format(cents / 100) + ' ' + ((cart?.currency || 'EGP') === 'EGP' ? 'ج.م' : cart.currency);
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  const snapshot = doc => {const node = doc?.querySelector('[data-mouni-cart-page-snapshot], [data-mouni-cart-snapshot]'); try {return node ? JSON.parse(node.textContent) : null;} catch (_) {return null;}};
  const readSnapshot = () => cart = snapshot(page()) || snapshot(drawer()) || cart;
  const rowItem = key => cart?.items?.find(item => item.key === key);
  const minimumFor = item => window.MouniCommerce?.cartMinimum?.(item?.variant_id ?? item?.id) || window.MouniCommerce?.minimum(item?.variant_id ?? item?.id) || 1;
  const nativeOffer = item => !!window.MouniCommerce?.bonus(item?.variant_id ?? item?.id);
  const nativeBonus = item => !!window.MouniCommerce?.isBonus(item);
  const getLimit = (row,state=cart) => {
    const item=state?.items?.find(i=>i.key===row.dataset.key);
    if(nativeOffer(item)&&row.dataset.stockTotal!==''){
      const stock=Math.max(0,Number(row.dataset.stockTotal));
      return stock>=2?Math.max(1,stock-1):stock;
    }
    if(row.dataset.stockTotal==='' || row.dataset.stockTotal==null)return row.dataset.stockLimit===''||row.dataset.stockLimit==null?Infinity:Math.max(0,Number(row.dataset.stockLimit));
    const others=(state?.items||[]).filter(item=>String(item.variant_id)===String(row.dataset.variantId)&&item.key!==row.dataset.key).reduce((sum,item)=>sum+Number(item.quantity),0);
    return Math.max(0,Number(row.dataset.stockTotal)-others);
  };
  const errorMessage = message => {
    for (const host of [drawer()?.querySelector('.halo-sidebar-header'), page()]) {
      if (!host) continue;
      let el = host.querySelector('[data-mouni-cart-error]');
      if (!el && message) {el = document.createElement('p'); el.dataset.mouniCartError = ''; el.setAttribute('role','alert'); host.prepend(el);}
      if (el) el.textContent = message;
    }
  };
  const burst = row => {
    if (settings().giftSurprise === 'false' || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const host = row.closest('#halo-cart-sidebar, [data-mouni-cart-page]');
    if (!host || (host === drawer() && !document.body.classList.contains('cart-sidebar-show'))) return;
    if (host) host.dataset.giftCelebrations = String(Number(host.dataset.giftCelebrations || 0) + 1);
    clearTimeout(burstTimers.get(host));
    document.querySelector('.mouni-gift-burst')?.remove();
    const fx = document.createElement('span'); fx.className = 'mouni-gift-burst'; fx.setAttribute('aria-hidden','true');
    const rowBounds = row.getBoundingClientRect();
    // Keep the effect outside sections which GiftPro replaces during refresh.
    fx.style.position = 'fixed';
    fx.style.left = (rowBounds.left + rowBounds.width / 2) + 'px';
    fx.style.top = Math.max(80, Math.min(innerHeight - 80, rowBounds.top + rowBounds.height / 2)) + 'px';
    fx.style.zIndex = '2147483100';
    const seal = document.createElement('b'); seal.textContent = '🎁'; fx.append(seal);
    for (let i = 0; i < 32; i++) {
      const particle = document.createElement('i'), angle = i * Math.PI * 2 / 32;
      particle.style.setProperty('--x', Math.round(Math.cos(angle) * (85 + i % 4 * 22)) + 'px');
      particle.style.setProperty('--y', Math.round(Math.sin(angle) * 85 - 25) + 'px');
      particle.style.setProperty('--r', (i * 47) + 'deg');
      particle.style.background = ['#f41487','#ffd43b','#0985d4','#48cbb5'][i % 4]; fx.append(particle);
    }
    document.body.append(fx); row.classList.remove('mouni-gift-surprise');
    requestAnimationFrame(() => row.classList.add('mouni-gift-surprise'));
    burstTimers.set(host, setTimeout(() => {fx.remove(); row.classList.remove('mouni-gift-surprise');}, 1800));
  };
  const paintSummary = state => {
    const sum = api.summary(state);
    window.MouniCommerce?.updateCartCount(sum.count);
    document.querySelectorAll('[data-mouni-paid-count], #halo-cart-sidebar [data-cart-count]').forEach(n => n.textContent = sum.count);
    document.querySelectorAll('[data-mouni-paid-total]').forEach(n => n.innerHTML = money(sum.total));
    document.querySelectorAll('[data-mouni-cart-total-amount]').forEach(n => n.textContent = (sum.total / 100).toLocaleString('en-US', {maximumFractionDigits:2}));
    document.querySelectorAll('[data-mouni-paid-subtotal]').forEach(n => n.innerHTML = money(sum.original));
    document.querySelectorAll('[data-saved-discount-value]').forEach(n => n.innerHTML = money(Math.max(0, sum.original - sum.total)));
    document.querySelectorAll('[data-saved-discount-display]').forEach(n => n.style.display = sum.original > sum.total ? '' : 'none');
    const total = drawer()?.querySelector('[data-mouni-v27-total-number]');
    if (total) total.textContent = (sum.total / 100).toLocaleString('en-US', {maximumFractionDigits:2});
    const eligible = sum.total >= (Number(settings().giftThreshold) || 150000);
    let actualVisible = false;
    rows().forEach(row => {const item = state.items.find(i => i.key === row.dataset.key); if (item && api.isGift(item)) {row.hidden = !eligible; row.dataset.mouniGift = 'true'; if (eligible) actualVisible = true;}});
    for (const host of [drawer()?.querySelector('.previewCartList'), page()?.querySelector('.cart-list')]) {
      if (!host) continue;
      // Keep gift rows first in both visual and reading order after every refresh.
      [...host.querySelectorAll(':scope > [data-mouni-gift="true"]')].reverse().forEach(row => {
        if (host.firstElementChild !== row) host.prepend(row);
      });
      // A qualifying subtotal is not proof of an available GiftPro reward.
      // Display only actual gift lines supplied by the app, never a placeholder.
      host.querySelectorAll('[data-mouni-gift-pending]').forEach(row => row.remove());
    }
    return eligible && actualVisible;
  };
  // A drawer refresh or another increase above the threshold is not a new reward.
  const flushGiftCelebration = () => {
    if (!giftCelebrationPending) return;
    for (const host of [drawer(), page()]) {
      if (!host || (host === drawer() && !document.body.classList.contains('cart-sidebar-show'))) continue;
      const surface = host === drawer() ? 'drawer' : 'page';
      if (giftCelebrated.has(surface)) continue;
      const row = host.querySelector('[data-mouni-gift="true"]:not([hidden]):not(.mouni-v37-gift-transition-hidden)');
      if (row && row.getClientRects().length) {
        // Consume before animating, and celebrate on only the visible cart surface.
        rememberCelebration(surface);
        giftCelebrationPending = giftCelebrated.size < 2;
        // Wait for the drawer's entrance so the burst uses its final position.
        const animations = host.getAnimations?.({subtree:false}) || [];
        Promise.race([Promise.allSettled(animations.map(animation => animation.finished)), new Promise(resolve => setTimeout(resolve, 400))]).then(() => {
          const current = host.querySelector('[data-mouni-gift="true"]:not([hidden])');
          if (current && giftEligible) burst(current);
        });
        break;
      }
    }
  };
  const paint = state => {
    if (!state) return;
    paintSummary(state);
    // Replacing cart sections can temporarily remove the gift DOM. That is not
    // a new threshold crossing and must never re-arm the celebration.
    const eligible = api.summary(state).total >= (Number(settings().giftThreshold) || 150000);
    if (eligible && giftCelebrated.size < 2) giftCelebrationPending = true;
    if (!eligible) {giftCelebrationPending = false; rememberCelebration(false);}
    giftEligible = eligible;
    rows().forEach(row=>{const item=state.items.find(i=>i.key===row.dataset.key);if(!item||api.isGift(item)||nativeBonus(item))return;const limit=getLimit(row,state);row.querySelectorAll('[data-plus-quantity-cart]').forEach(plus=>{const blocked=item.quantity>=limit;plus.hidden=false;plus.disabled=blocked;plus.tabIndex=blocked?-1:0;plus.setAttribute('aria-disabled',String(blocked));});row.querySelectorAll('[data-cart-quantity]').forEach(input=>{if(Number.isFinite(limit))input.max=String(limit);else input.removeAttribute('max');});});
    rows().forEach(row=>{
      const item=state.items.find(i=>i.key===row.dataset.key);if(!item||api.isGift(item))return;
      if(nativeBonus(item)){
        row.dataset.mouniNativeBonus='true';
        row.querySelectorAll('cart-update-quantity,.previewCartItem-options,.cart-item-option,[data-cart-remove],[data-mouni-minimum-notice]').forEach(el=>{el.hidden=true;el.style.display='none';});
        return;
      }
      const minimum=minimumFor(item);
      row.querySelectorAll('[data-cart-quantity]').forEach(input=>{input.min=String(minimum);input.value=String(item.quantity);});
      row.querySelectorAll('[data-minus-quantity-cart]').forEach(button=>{button.disabled=item.quantity<=minimum;button.setAttribute('aria-disabled',String(button.disabled));});
      let notice=row.querySelector('[data-mouni-minimum-notice]');
      if(minimum>1&&!notice){notice=document.createElement('p');notice.dataset.mouniMinimumNotice='';notice.className='mouni-minimum-notice';row.append(notice);}
      if(notice){notice.hidden=minimum<=1;notice.textContent=`الحد الأدنى للعرض ${minimum.toLocaleString('ar-EG')} قطعة`;}
    });
    if(window.MouniCommerce){window.MouniCommerce.cart=state;document.querySelectorAll('form[data-mouni-enabled="true"]').forEach(form=>window.MouniCommerce.syncForm(form,state));}
    document.dispatchEvent(new CustomEvent('mouni:inventory-cart',{detail:{cart:state}}));
    flushGiftCelebration();
  };
  const projected = () => ({...cart, items:cart.items.map(item => {
    if(nativeBonus(item)){
      const change=[...pending.values()].find(change=>String(change.item.variant_id)===String(item.variant_id));
      if(change && change.quantity<2)return {...item,quantity:0};
    }
    const change = pending.get(item.key); if (!change) return item;
    return {...item, quantity:change.quantity, final_line_price:change.quantity * item.final_price, original_line_price:change.quantity * item.original_price};
  }).filter(item => item.quantity > 0)});
  const optimistic = () => {
    if (!cart) return;
    rows().forEach(row => {
      if(row.dataset.mouniNativeBonus==='true'){
        const item=rowItem(row.dataset.key);
        const paidChange=[...pending.values()].find(change=>String(change.item.variant_id)===String(item?.variant_id));
        if(paidChange)row.hidden=paidChange.quantity<2;
      }
      const change = pending.get(row.dataset.key); if (!change) return;
      row.hidden = change.quantity === 0;
      row.querySelectorAll('[data-cart-quantity]').forEach(input => input.value = change.quantity);
      row.querySelectorAll('[data-plus-quantity-cart]').forEach(plus => {const blocked = change.quantity >= getLimit(row); plus.hidden = false; plus.disabled = blocked; plus.tabIndex = blocked ? -1 : 0; plus.setAttribute('aria-disabled', String(blocked));});
      row.querySelectorAll('[data-item-price-with-quantity-display]').forEach(n => n.innerHTML = money(change.quantity * change.item.final_price));
      row.classList.add('mouni-cart-pending');
    });
    paint(projected());
  };
  const render = (sections, next) => {
    const wrapper = drawer()?.querySelector('.previewCart-wrapper');
    if (wrapper && sections?.['mouni-cart-content']) {const doc = parse(sections['mouni-cart-content']); wrapper.innerHTML = (doc.querySelector('#shopify-section-mouni-cart-content') || doc.body).innerHTML;}
    const currentPage = page(), pageHTML = sections?.[currentPage?.dataset.sectionId];
    if (currentPage && pageHTML) {
      const fresh = parse(pageHTML).querySelector('[data-mouni-cart-page]');
      if (fresh) {
        const fields = [...currentPage.querySelectorAll('textarea, input[name="discount"], input[name="conditions"]')].map(el => ({name:el.name, value:el.value, checked:el.checked}));
        currentPage.innerHTML = fresh.innerHTML;
        fields.forEach(field => currentPage.querySelectorAll('textarea, input[name="discount"], input[name="conditions"]').forEach(el => {if (el.name === field.name) {el.value = field.value; if (el.type === 'checkbox') {el.checked = field.checked; el.dispatchEvent(new Event('change', {bubbles:true}));}}}));
      }
    }
    cart = next;
    if (window.MouniCommerce) {window.MouniCommerce.cart = next; window.MouniCommerce.syncAll(false);}
    window.MouniQuickCartV37?.render(next);
    paint(next);
    confirmedDrawer = wrapper?.innerHTML || ''; confirmedPage = page()?.innerHTML || '';
    document.dispatchEvent(new CustomEvent('mouni:cart-html-refreshed', {detail:{cart:next}}));
    scheduleGiftSync(next);
  };
  api.consumeHTML = html => {
    const next = snapshot(parse(html || '')); if (!next) return null;
    render({'mouni-cart-content':html}, next); return next;
  };
  const sectionIDs = () => ['mouni-cart-content', page()?.dataset.sectionId].filter(Boolean);
  const reconcile = () => {
    if (refresh) return refresh;
    refresh = (async () => {
      const response = await fetch(`${location.pathname}?sections=${sectionIDs().join(',')}`, {credentials:'same-origin'});
      if (!response.ok) throw new Error('تعذر تحديث السلة، حاولي مرة أخرى.');
      const sections = await response.json(); const next = snapshot(parse(sections['mouni-cart-content'] || ''));
      if (!next) throw new Error('تعذر تحميل السلة.');
      render(sections, next); return next;
    })().finally(() => refresh = null);
    return refresh;
  };
  api.refresh = reconcile;
  const drain = async () => {
    if (running) return; running = true;
    try {
      while (pending.size) {
        const [key, change] = pending.entries().next().value, sentQuantity = change.quantity;
        const candidates = cart.items.filter(i => i.variant_id === change.item.variant_id && JSON.stringify(i.properties || {}) === JSON.stringify(change.item.properties || {}));
        const actual = rowItem(key) || candidates.find(item=>!nativeBonus(item));
        if (!actual) {pending.delete(key); continue;}
        const body={id:actual.key, quantity:sentQuantity, sections:sectionIDs(), sections_url:location.pathname};
        if(nativeOffer(actual)){
          body.updates={};
          candidates.forEach(item=>body.updates[item.key]=item.key===actual.key?window.MouniCommerce.physicalQuantity(actual.variant_id,sentQuantity):0);
          body.updates[actual.key]=window.MouniCommerce.physicalQuantity(actual.variant_id,sentQuantity);
          delete body.id;delete body.quantity;
        }
        const response = await fetch(`${root}cart/${body.updates?'update':'change'}.js`, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify(body)});
        const next = await response.json();
        if (!response.ok || !Array.isArray(next.items)) throw new Error(next.description || 'تعذر تحديث السلة، حاولي مرة أخرى.');
        cart = next; latestSections = next.sections;
        if (pending.get(key)?.quantity === sentQuantity) pending.delete(key);
        else {const updated = next.items.find(i => i.variant_id === actual.variant_id && !api.isGift(i) && !nativeBonus(i)); if (updated) pending.get(key).item = updated;}
        optimistic();
      }
      running = false;
      if (latestSections?.['mouni-cart-content']) render(latestSections, cart); else await reconcile();
    } catch (error) {
      pending.clear(); running = false;
      try {await reconcile();} catch (_) {
        const wrapper = drawer()?.querySelector('.previewCart-wrapper'); if (wrapper && confirmedDrawer) wrapper.innerHTML = confirmedDrawer;
        if (page() && confirmedPage) page().innerHTML = confirmedPage;
        readSnapshot(); paint(cart);
      }
      errorMessage(error.message || 'تعذر تحديث السلة، حاولي مرة أخرى.');
    } finally {running = false;}
  };
  const change = (row, quantity) => {
    if (api.checkoutBusy) return true;
    if (!row) return false;
    if (!api.busy) {readSnapshot(); confirmedDrawer = drawer()?.querySelector('.previewCart-wrapper')?.innerHTML || ''; confirmedPage = page()?.innerHTML || '';}
    const key = row.dataset.key, item = rowItem(key);
    if (!item || api.isGift(item)) return false;
    if(nativeBonus(item))return true;
    quantity = Math.max(0, Math.floor(Math.min(quantity, getLimit(row,projected()))));
    if (!Number.isFinite(quantity)) return false;
    if(quantity>0&&quantity<minimumFor(item)){
      errorMessage(`الحد الأدنى لهذا العرض ${minimumFor(item).toLocaleString('ar-EG')} قطعة. يمكنك إزالة العرض بالكامل.`);
      paint(projected());return true;
    }
    if(quantity===(pending.get(key)?.quantity ?? item.quantity))return true;
    pending.set(key, {quantity, item}); errorMessage(''); optimistic(); void drain(); return true;
  };
  const scope = '#halo-cart-sidebar, [data-mouni-cart-page]';
  const checkoutSelector = '#cart-sidebar-checkout,#cart-checkout,.mouni-v27-checkout,a[href$="/checkout"],button[name="checkout"],input[name="checkout"]';
  const pause = ms => new Promise(resolve => setTimeout(resolve, ms));
  const freshCart = async () => {
    const response = await fetch(`${root}cart.js`, {credentials:'same-origin', cache:'no-store', signal:AbortSignal.timeout(8000)});
    if (!response.ok) throw new Error('تعذر تأكيد السلة. حاولي إتمام الشراء مرة أخرى.');
    const next = await response.json();
    if (!Array.isArray(next.items)) throw new Error('تعذر تأكيد السلة.');
    cart = next;
    if (window.MouniCommerce) window.MouniCommerce.cart = next;
    return next;
  };
  const giftConfirmed = (state, gift) => state.items.filter(item =>
    String(item.variant_id) === gift.variantId && String(item.properties?._auto_added_by_rule) === String(gift.ruleId) &&
    item.final_line_price === 0
  ).reduce((sum,item)=>sum+item.quantity,0) >= gift.quantity;
  const trimDuplicateGifts = async (state, matches) => {
    const updates={};
    for(const match of matches)for(const action of match.actions||[]){
      if(action.type!=='add_product'||action.gift_source==='mirror_trigger')continue;
      const variantId=String(action.variant?.id||action.variant_id||'').split('/').pop();
      let remaining=Number(action.quantity)||1;
      const lines=state.items.filter(item=>String(item.variant_id)===variantId&&String(item.properties?._auto_added_by_rule)===String(match.ruleId)&&String(item.properties?._auto_added)==='true');
      for(const line of lines){const quantity=Math.min(remaining,line.quantity);remaining-=quantity;if(quantity!==line.quantity)updates[line.key]=quantity;}
    }
    if(!Object.keys(updates).length)return state;
    const response=await fetch(`${root}cart/update.js`,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates}),signal:AbortSignal.timeout(8000)});
    const next=await response.json();
    if(!response.ok||!Array.isArray(next.items))throw new Error('تعذر تأكيد عدد الهدايا. حاولي مرة أخرى.');
    return next;
  };
  // GiftPro remains the authority for qualification, stock and adding the gift.
  // This only prevents navigation before its real zero-price cart line exists.
  const confirmGiftPro = async state => {
    if (api.summary(state).total < (Number(settings().giftThreshold) || 150000)) {
      if (!state.items.some(api.isGift)) return state;
      document.dispatchEvent(new CustomEvent('giftpro:request-qualification'));
      const removalDeadline=Date.now()+12000;
      while(Date.now()<removalDeadline){
        state=await freshCart();
        if(!state.items.some(api.isGift))return state;
        if(api.summary(state).total >= (Number(settings().giftThreshold)||150000))break;
        await pause(150);
      }
      if(api.summary(state).total < (Number(settings().giftThreshold)||150000))throw new Error('تعذر تأكيد تحديث الهدية. حاولي مرة أخرى.');
    }
    const deadline = Date.now() + 12000;
    while (!Array.isArray(window.cartRules) || !window.__GiftproRuleValidator || !window.__giftproAtcCoreInit) {
      if (Date.now() >= deadline) throw new Error('تعذر تأكيد الهدية. حاولي إتمام الشراء مرة أخرى.');
      await pause(100);
    }
    const rules = window.cartRules;
    if (!rules.length) return state;
    const context = {
      customerId:window.giftproCustomer?.id,
      customerTags:window.giftproCustomer?.tags || [],
      itemCollections:Object.fromEntries(state.items.map(item=>[
        String(item.variant_id), window.__giftproProductCollectionMap?.[`gid://shopify/Product/${item.product_id}`] || []
      ]))
    };
    const matches = new window.__GiftproRuleValidator(rules).validateCart(state, context);
    state = await trimDuplicateGifts(state, matches);
    const expected = [];
    for (const match of matches) for (const action of match.actions || []) {
      if (action.type !== 'add_product' || action.gift_source === 'mirror_trigger' ||
          (action.discount_type && action.discount_type !== 'free')) continue;
      const variantId = String(action.variant?.id || action.variant_id || '').split('/').pop();
      const gift = {variantId, ruleId:match.ruleId, quantity:Number(action.quantity)||1};
      if (!variantId || giftConfirmed(state,gift)) continue;
      const handle = action.variant?.handle;
      if (!handle) throw new Error('تعذر تأكيد توافر الهدية. حاولي مرة أخرى.');
      const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, {cache:'no-store',signal:AbortSignal.timeout(8000)});
      if (response.status === 404) continue;
      if (!response.ok) throw new Error('تعذر تأكيد توافر الهدية. حاولي مرة أخرى.');
      const product = await response.json();
      const variant = product.variants?.find(v=>String(v.id)===variantId);
      // A sold-out/deleted reward must never block a normal purchase or be added.
      if (!variant || variant.available === false) continue;
      if (variant.available !== true) throw new Error('تعذر تأكيد توافر الهدية.');
      expected.push(gift);
    }
    if (!expected.length) return state;
    document.dispatchEvent(new CustomEvent('giftpro:request-qualification'));
    while (Date.now() < deadline) {
      state = await freshCart();
      // A customer can lower the quantity while the app is qualifying a gift.
      // Stop the old claim rather than applying an obsolete threshold decision.
      if (api.summary(state).total < (Number(settings().giftThreshold) || 150000)) return state;
      const missing = expected.filter(gift=>!giftConfirmed(state,gift));
      if (!missing.length) return trimDuplicateGifts(state,matches);
      // GiftPro's automatic add is the only writer. A second claim races it
      // and can create a second line with different app properties.
      await pause(150);
    }
    throw new Error('لم يتم تأكيد الهدية بعد. حاولي إتمام الشراء مرة أخرى؛ لم ننتقل للدفع بدونها.');
  };
  const scheduleGiftSync = state => {
    if (!state?.items || api.busy || api.checkoutBusy) return;
    if (api.summary(state).total < (Number(settings().giftThreshold) || 150000)) {giftSyncSignature='';return;}
    const nextSignature=signature({...state,items:state.items.filter(item=>!api.isGift(item))});
    if (giftSync || giftSyncSignature===nextSignature) return;
    giftSyncSignature=nextSignature;
    // Start qualification on the confirmed cart update, not at the checkout click.
    giftSync=confirmGiftPro(state).then(async confirmed=>{
      const missingGift = confirmed.items.some(api.isGift) && !drawer()?.querySelector('[data-mouni-gift="true"]');
      if (!api.busy && (signature(confirmed)!==signature(state) || missingGift)) await reconcile();
    }).catch(error=>{if(!api.busy)errorMessage(error.message);}).finally(()=>{
      giftSync=null;
      if(cart) scheduleGiftSync(cart);
    });
  };
  api.checkout = async button => {
    if (api.checkoutBusy) return;
    api.checkoutBusy = true;
    const original = button?.textContent;
    if (button) {button.setAttribute('aria-busy','true'); button.textContent='جاري تأكيد السلة…';}
    errorMessage('');
    try {
      const deadline = Date.now() + 15000;
      while (api.busy || refresh || window.MouniCommerce?.busy) {
        if (Date.now() >= deadline) throw new Error('تعذر تحديث السلة. حاولي مرة أخرى.');
        await pause(50);
      }
      let next = await freshCart();
      const invalid = window.MouniCommerce?.invalidMinimum(next) || window.MouniCommerce?.invalidOffer?.(next);
      if (invalid) throw new Error(`لم يتم تأكيد عرض ${invalid.title}. راجعي الكمية قبل الدفع.`);
      if (giftSync) {await giftSync;next=await freshCart();}
      next = await confirmGiftPro(next);
      if (!next.items.length) throw new Error('السلة فارغة.');
      window.location.assign(`${root}checkout`);
    } catch (error) {
      errorMessage(error.message || 'تعذر تأكيد السلة. حاولي مرة أخرى.');
      if (button) {button.textContent=original;button.removeAttribute('aria-busy');}
    } finally {api.checkoutBusy = false;}
  };
  window.addEventListener('click',event=>{
    const button=event.target.closest?.(checkoutSelector);
    if(!button || button.disabled)return;
    event.preventDefault();event.stopImmediatePropagation();
    void api.checkout(button);
  },true);
  window.addEventListener('submit',event=>{
    if(!event.submitter?.matches?.(checkoutSelector))return;
    event.preventDefault();event.stopImmediatePropagation();
    void api.checkout(event.submitter);
  },true);
  window.addEventListener('click', event => {
    const button = event.target.closest?.('[data-plus-quantity-cart], [data-minus-quantity-cart], [data-cart-remove]');
    if (!button?.closest(scope)) return;
    const row = button.closest('.previewCartItem, [data-mouni-cart-row]');
    const current = Number(row?.querySelector('[data-cart-quantity]')?.value || 1);
    const quantity = button.hasAttribute('data-cart-remove') ? 0 : current + (button.hasAttribute('data-plus-quantity-cart') ? 1 : -1);
    if (change(row, quantity)) {event.preventDefault(); event.stopImmediatePropagation();}
  }, true);
  window.addEventListener('change', event => {
    const input = event.target;
    if (!input.matches?.('[data-cart-quantity]') || !input.closest(scope)) return;
    if (change(input.closest('.previewCartItem, [data-mouni-cart-row]'), Number(input.value))) {event.preventDefault(); event.stopImmediatePropagation();}
  }, true);
  document.addEventListener('mouni:v37-cart-painted', event => {
    const next = event.detail?.cart || event.detail;
    if (!next?.items || api.busy) return;
    if (signature(next) !== signature(cart)) {cart = next; void reconcile().catch(() => paint(next));}
    else {paint(next);scheduleGiftSync(next);}
  });
  let observedSnapshot = null;
  const adoptSnapshot = () => {
    const node = drawer()?.querySelector('[data-mouni-cart-snapshot]');
    if (!api.busy && node && node !== observedSnapshot) {observedSnapshot = node; readSnapshot(); paint(cart);}
  };
  const init = () => {
    readSnapshot(); if (cart) {paint(cart);scheduleGiftSync(cart);}
    const host = drawer(); if (host) new MutationObserver(adoptSnapshot).observe(host, {subtree:true, childList:true});
    // GiftPro may replace either cart surface without emitting our paint event.
    new MutationObserver(flushGiftCelebration).observe(document.body, {subtree:true, childList:true});
    let wasOpen = document.body.classList.contains('cart-sidebar-show');
    new MutationObserver(() => {
      const open = document.body.classList.contains('cart-sidebar-show');
      if (open && !wasOpen) {
        // One surprise per intentional opening, never per app refresh.
        giftCelebrated.delete('drawer');
        try { sessionStorage.setItem(celebrationKey, JSON.stringify([...giftCelebrated])); } catch (_) {}
        giftCelebrationPending = giftEligible === true;
        flushGiftCelebration();
        // Opening the drawer must recover app updates missed while it was closed.
        if (!api.busy && !api.checkoutBusy) {
          giftSyncSignature = '';
          void reconcile().catch(error => errorMessage(error.message));
        }
      }
      wasOpen = open;
    }).observe(document.body, {attributes:true, attributeFilter:['class']});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
